import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import {
    ApplicationConfig,
    ErrorHandler,
    importProvidersFrom,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { TranslateUniversalLoader } from '../translate-universal';
import { routes } from './app.routes';
import { AuthService } from './shared/auth-helpers/auth.service';
import { ApiInterceptor } from './shared/helpers/api-interceptor';
import { FormErrorsService } from './shared/services/form-errors.service';

import './shared/helpers/sentry';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: TranslateUniversalLoader,
                },
            }),
            AuthService,
            FormErrorsService,
        ),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
        provideCharts(withDefaultRegisterables()),
    ],
};
